import React, { useRef, useState } from "react"
import moment from "moment"
import "moment/locale/bg"
import { Popover, Typography, Box } from "@mui/material"
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import { YearCalendar } from "@mui/x-date-pickers"
import { trans } from "@/_providers/Translation"
import { useAuthDataContext } from "@/_providers/Auth"

moment.locale("bg")

export default function DatePicker({
  date,
  onDateChange,
  disabled,
  yearOnly = false,
  placeholder,
  fullDateFormat = 'DD MMM, YY',
}) {
  const { lang } = useAuthDataContext()

  const containerRef = useRef(null)
  const [anchorEl, setAnchorEl] = useState(null)

  const formatDate = (dateString) => {
    if (!dateString) return ""
    if (yearOnly) return `${dateString} г.`
    return moment(dateString).format(fullDateFormat)
  }

  const handleDateChange = (newValue) => {
    const newDate = newValue
      ? newValue.format(yearOnly ? "YYYY" : "YYYY-MM-DD")
      : null
    onDateChange?.(newDate)
    handleClose()
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleContainerClick = () => {
    if (disabled) return
    setAnchorEl(containerRef.current)
  }

  const open = Boolean(anchorEl)

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={lang()}>
      <div
        className="date-range-picker"
        ref={containerRef}
        onClick={handleContainerClick}
        style={{
          pointerEvents: disabled ? "none" : "auto",
          opacity: disabled ? 0.4 : 1,
        }}
      >
        <div className="date-range-display">
          {!date || !String(date).length ? (
            <span style={{ paddingLeft: "5px" }}>
              {placeholder || trans("random.select")}
            </span>
          ) : (
            <span className="date-range-start">
              {formatDate(date)}
            </span>
          )}
        </div>
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{ zIndex: 999999 }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              borderRadius: 2,
            },
          },
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ pt: 2, px: 3, color: "text.secondary", fontWeight: 600 }}
        >
          {trans("random.selectDate")}
        </Typography>
        <Box>
          {yearOnly ? (
            <YearCalendar
              value={date ? moment(date, "YYYY") : null}
              onChange={handleDateChange}
            />
          ) : (
            <DateCalendar
              value={date ? moment(date) : null}
              onChange={handleDateChange}
            />
          )}
        </Box>
      </Popover>
    </LocalizationProvider>
  )
}
